export default __webpack_public_path__ + "static/ingo-feed-test-e24187c95ff0ef6cb70266c0bb496964.jpg";